/** Разбор адреса `/results` в серверный фильтр ленты (чистая логика, без React). */
import type { ResultFilter } from "../../../lib/results";

export const KINDS = ["shot", "fitting", "reference", "manual", "clip", "upload", "enhance"];
export const STATUSES = ["done", "active", "failed"];
export const POSTED = ["yes", "no"];

export function pick(raw: string | null, allowed: string[]): string | undefined {
  return raw && allowed.includes(raw) ? raw : undefined;
}

/** `search` — URLSearchParams (достаточно `get`). `author=0` сохраняется; пустой/нецелый/отрицательный — нет. */
export function parseResultFilter(search: { get(key: string): string | null }): ResultFilter {
  const authorParam = search.get("author");
  const authorRaw = authorParam === null || authorParam === "" ? NaN : Number(authorParam);
  return {
    ...(pick(search.get("kind"), KINDS) ? { kind: pick(search.get("kind"), KINDS)! } : {}),
    ...(pick(search.get("status"), STATUSES) ? { status: pick(search.get("status"), STATUSES)! } : {}),
    // старые закладки `?picked=1` — это «В улучшение»
    ...(search.get("pick") === "publish"
      ? { pick: "publish" as const }
      : search.get("pick") === "enhance" || search.get("picked") === "1"
        ? { pick: "enhance" as const }
        : {}),
    ...(pick(search.get("posted"), POSTED) ? { posted: pick(search.get("posted"), POSTED)! } : {}),
    ...(search.get("network") ? { network: search.get("network")! } : {}),
    ...(Number.isInteger(authorRaw) && authorRaw >= 0 ? { author: authorRaw } : {}),
  };
}
